import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia con ChatGPT?',
  a: 'No. Es un sistema guiado y viene con videos.'
}, {
  q: '¿Sirve para cualquier nicho?',
  a: 'Sí. El método se adapta a tu tema porque parte de tu avatar y promesa.'
}, {
  q: '¿Qué obtengo al final?',
  a: 'Un ebook estructurado con capítulos, ejercicios/checklists y un cierre con CTA, listo para maquetar en PDF y vender.'
}, {
  q: '¿Esto me garantiza ventas?',
  a: 'No. Te garantiza el producto y la claridad. La venta depende de tu tráfico y ejecución.'
}, {
  q: '¿Cómo accedo?',
  a: 'Luego de tu compra tendrás acceso inmediato por correo electrónico.'
}];
function FaqItem({
  faq,
  index
}: {
  faq: {
    q: string;
    a: string;
  };
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-800 last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-6 text-left group" data-id="element-2">
        <h3 className="text-xl font-bold text-white pr-4 group-hover:text-[#00d4aa] transition-colors" data-id="element-3">
          {faq.q}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-4">
          <ChevronDown className="w-5 h-5 text-[#00d4aa]" data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-7">
            <p className="text-gray-400 leading-relaxed text-lg pb-6" data-id="element-8">
              {faq.a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function AudienceSection() {
  return <section className="w-full py-24 px-6 bg-[#050505]" data-id="element-9">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-10">
        {/* Creator */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-11">
          <h2 className="text-2xl font-bold text-[#f0f0f0]" data-id="element-12">
            Creado por Mauricio Medina
          </h2>
          <p className="text-gray-400 leading-relaxed text-lg" data-id="element-13">
            Estratega en inteligencia artificial aplicada a infoproductos, con
            más de 10 años en marketing digital. Desarrolló EBOOK CREATOR para
            resolver el mayor bloqueo del principiante:{' '}
            <strong data-id="element-14">
              pasar de idea a producto terminado con orden y claridad.
            </strong>
          </p>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#0a0f0d] border border-gray-800 rounded-2xl p-8 md:p-12 text-center space-y-6" data-id="element-15">
          <div className="flex justify-center" data-id="element-16">
            <img src="https://i.postimg.cc/pdJHXbS9/selo-garantia-png-2.webp" alt="Garantía de 7 días" className="w-32 h-32 object-contain" data-id="element-17" />
          </div>
          <h2 className="text-3xl font-bold text-[#f0f0f0]" data-id="element-18">
            Garantía de 7 días (satisfacción)
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed" data-id="element-19">
            Pruébalo sin riesgo. Si en 7 días sientes que no es para ti,
            solicitas reembolso según nuestras políticas de devolución.
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-20">
          <h2 className="text-3xl font-bold text-[#f0f0f0] mb-12 text-center" data-id="element-21">
            Preguntas Frecuentes
          </h2>
          <div data-id="element-22">
            {faqs.map((faq, i) => <FaqItem key={i} faq={faq} index={i} data-id="element-23" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}